export default __webpack_public_path__ + "assets/images/esikoululainen-62e6cee1c3ec4bb93b5b305471966e6e.jpg";